import { Directive } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { helperFunctions } from 'src/app/utils/cf-checker-util';

export function ValidateCF(control: AbstractControl): {[key: string]: any} | null  {
    
    if (control.parent && control.parent.get('cognomeDenominazione').value && control.parent.get('nome').value && control.parent.get('sesso').value && control.parent.get('codiceFiscale').value) {
        const cognome = control.parent.get('cognomeDenominazione').value;
        const nome = control.parent.get('nome').value;
        const sesso = control.parent.get('sesso').value;
        const CF = control.parent.get('codiceFiscale').value;
    
        const cfCheckerResult = helperFunctions.checkCodiceFiscale(cognome, nome, null, sesso, null, CF, false);
        return (cfCheckerResult === true) ? null : { cfnotvalid: true } ;
    }
    
    return null; // return null if validation is passed.
}

@Directive({
  selector: '[appCodiceFiscaleValidatorDirective]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: AppCodiceFiscaleValidatorDirective,
    multi: true
  }]
})
export class AppCodiceFiscaleValidatorDirective implements Validator {
  validate(control: AbstractControl) : {[key: string]: any} | null {
    return ValidateCF(control);
  }
}